import React from 'react'
import img1 from "../../Assets/images/img21.png"
import img2 from "../../Assets/images/home-banner-21.png"
const Banner = () => {
  return (
    <>
    <section className='section-top-padding'>
        <div className='container'>
          <div className='image-bg-banner'>
            <div className='row'>
              <div className='col-lg-6 pe-lg-5 d-flex flex-column justify-content-center'>
                  <h2 className='fs-2'>Prepare, Learn, and Stand Out</h2>
                  <ul className='text-white list'>
                    <li>
                      Interview tips and preparation guides  
                    </li>
                    <li>
Sample assignments and practice quizzes
                    </li>
                    <li>
Blogs on career development
                    </li>
                  </ul>
                  {/* <p>Partnering with top MBA schools like IIMs and other leading universities to provide verified, job-ready fresher talent.</p> */}
              </div>
              <div className='col-lg-6 text-end d-flex'>
                  <div  className='shadow-img'><img src={img1} alt='' /></div>
                  <div  className='shadow-img'><img src={img2} alt='' /></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Banner